import React from 'react';

const BillingSkeleton: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center h-10">
        <div className="h-6 w-48 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
        <div className="h-10 w-40 bg-gray-200 dark:bg-neutral-700 rounded-xl animate-pulse" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="h-32 bg-white dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-xl p-4 flex flex-col justify-between">
            <div className="h-4 w-24 bg-gray-100 dark:bg-neutral-600 rounded animate-pulse" />
            <div className="h-8 w-32 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
          </div>
        ))}
      </div>

      <div className="space-y-3">
        <div className="h-4 w-32 bg-gray-100 dark:bg-neutral-600 rounded animate-pulse mx-2" />
        <div className="p-8 bg-white dark:bg-neutral-800 border border-gray-200 dark:border-neutral-700 rounded-xl space-y-8">
          <div className="flex items-center gap-6">
            <div className="h-20 w-20 bg-gray-100 dark:bg-neutral-600 rounded-2xl animate-pulse" />
            <div className="space-y-3 flex-1">
              <div className="h-6 w-48 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
              <div className="h-4 w-32 bg-gray-100 dark:bg-neutral-600 rounded animate-pulse" />
            </div>
            <div className="flex gap-3">
              <div className="h-9 w-24 bg-gray-200 dark:bg-neutral-700 rounded-lg animate-pulse" />
              <div className="h-9 w-32 bg-gray-200 dark:bg-neutral-700 rounded-lg animate-pulse" />
            </div>
          </div>
          
          <div className="pt-8 border-t border-gray-100 dark:border-neutral-700 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-8 gap-x-12">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="space-y-2 px-1">
                <div className="h-3 w-20 bg-gray-100 dark:bg-neutral-600 rounded animate-pulse" />
                <div className="h-5 w-40 bg-gray-200 dark:bg-neutral-700 rounded animate-pulse" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingSkeleton;
